import { Component, ReactNode } from 'react'

type Props = { children?: ReactNode }
type State = { hasError: boolean; error?: any }

export class ErrorBoundary extends Component<Props, State> {
  state: State = { hasError: false }
  static getDerivedStateFromError(error: any): State {
    return { hasError: true, error }
  }
  render() {
    if (this.state.hasError) {
      return (
        <div className="p-6">
          <h1 className="text-xl font-semibold mb-2">Something went wrong</h1>
          <pre className="text-sm text-muted whitespace-pre-wrap">{String(this.state.error)}</pre>
        </div>
      )
    }
    return this.props.children ?? null
  }
}

